import React from 'react';
import { useSolubilityStore } from '../store/useSolubilityStore';
import { Bar } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

export function SolubilityChart() {
  const results = useSolubilityStore(s => s.results);
  const sorted = [...results].sort((a, b) => a.targetTempC - b.targetTempC);

  const data = {
    labels: sorted.map(r => `${r.targetTempC}°C`),
    datasets: [
      {
        label: 'Dissolved (g)',
        data: sorted.map(r => r.dissolvedMassG),
        backgroundColor: 'rgba(16, 185, 129, 0.7)',
      },
      {
        label: 'Undissolved (g)',
        data: sorted.map(r => r.undissolvedMassG),
        backgroundColor: 'rgba(245, 158, 11, 0.7)',
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      x: { stacked: true },
      y: { stacked: true, max: 40, title: { display: true, text: 'Mass of salt (g)' } },
    },
    plugins: {
      legend: { position: 'top' as const },
      title: { display: true, text: 'Solubility of salt at different temperatures' },
    },
  };

  return (
    <div className="flex flex-col h-full">
      <h2 className="text-lg font-bold mb-3">Solubility Chart</h2>
      {sorted.length === 0 && (
        <p className="text-sm text-muted-foreground">Run trials to see the chart.</p>
      )}
      {sorted.length > 0 && (
        <div className="flex-1 min-h-[300px]">
          <Bar data={data} options={options} />
        </div>
      )}
    </div>
  );
}

export default SolubilityChart;
